import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ModalData, ModalIncompleteService } from './modal-incomplete.service';
import { Subscription } from 'rxjs';

declare var bootstrap: any;

@Component({
  selector: 'app-modal-incomplete',
  templateUrl: './modal-incomplete.component.html',
  styleUrl: './modal-incomplete.component.css'
})
export class ModalIncompleteComponent implements OnInit, OnDestroy, AfterViewInit {
  modalData: ModalData = {
    title: '',
    dates: [],
    detailData: [],
    businessLineId: 0,
    isVisible: false,
    isDetailView: false
  };

  private subscription: Subscription = new Subscription();
  private modalInstance: any = null;
  private isModalInitialized = false;

  constructor(private modalService: ModalIncompleteService) {}

  ngOnInit() {
    this.subscription = this.modalService.modalData$.subscribe(data => {
      this.modalData = data;

      if (this.isModalInitialized) {
        if (data.isVisible && !this.isModalOpen()) {
          this.openModal();
        } else if (!data.isVisible && this.isModalOpen()) {
          this.closeModalInstance();
        }
      }
    });
  }

  ngAfterViewInit() {
    this.initializeModal();
    this.isModalInitialized = true;

    if (this.modalData.isVisible) {
      setTimeout(() => this.openModal(), 100);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.modalInstance) {
      this.modalInstance.dispose();
    }
  }

  private initializeModal() {
    const modalElement = document.getElementById('incompleteDataModal');
    if (modalElement && typeof bootstrap !== 'undefined') {
      this.modalInstance = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: true
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.onModalHiddenEvent();
      });
    }
  }

  private openModal() {
    if (this.modalInstance && !this.isModalOpen()) {
      try {
        this.modalInstance.show();
      } catch (error) {
        console.error('Error showing modal:', error);
      }
    }
  }

  private closeModalInstance() {
    if (this.modalInstance && this.isModalOpen()) {
      try {
        this.modalInstance.hide();
      } catch (error) {
        console.error('Error hiding modal:', error);
      }
    }
  }

  private isModalOpen(): boolean {
    const modalElement = document.getElementById('incompleteDataModal');
    return modalElement?.classList.contains('show') || false;
  }

  closeModal() {
    this.modalService.hideModal();
  }

  private onModalHiddenEvent() {
    setTimeout(() => {
      this.modalService.resetModal();
    }, 100);
  }

  // Method untuk group data berdasarkan bulan dari period_label
  getGroupedDataByMonth(): any[] {
    if (!this.modalData.isDetailView || this.modalData.detailData.length === 0) {
      return [];
    }

    const groupedData: { [key: string]: any[] } = {};

    this.modalData.detailData.forEach(item => {
      const date = new Date(item.period_label);
      const monthKey = date.toLocaleString('en-US', { month: 'long', year: 'numeric' });

      if (!groupedData[monthKey]) {
        groupedData[monthKey] = [];
      }

      groupedData[monthKey].push({
        ...item,
        formattedDate: this.formatPeriodLabel(item.period_label)
      });
    });

    // Convert object to array dan sort berdasarkan tanggal
    return Object.keys(groupedData).map(month => ({
      month,
      dates: groupedData[month].sort((a, b) =>
        new Date(a.period_label).getTime() - new Date(b.period_label).getTime()
      )
    }));
  }

  // Format period_label sesuai kebutuhan tampilan
  private formatPeriodLabel(periodLabel: string): string {
    const date = new Date(periodLabel);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
  }

  // Method untuk fallback tampilan biasa (tanpa detail)
  getCurrentMonth(): string {
    if (this.modalData.dates.length === 0) {
      return '';
    }

    const firstDate = this.modalData.dates[0];
    let month = '';

    if (firstDate.includes('/')) {
      const parts = firstDate.split('/');
      if (parts.length === 3) {
        const monthNum = parseInt(parts[1]);
        month = this.getMonthName(monthNum);
      }
    } else if (firstDate.includes('-')) {
      const parts = firstDate.split('-');
      if (parts.length === 3) {
        const monthNum = parseInt(parts[1]);
        month = this.getMonthName(monthNum);
      }
    }

    return month || 'Dates';
  }

  private getMonthName(monthNum: number): string {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months[monthNum - 1] || '';
  }
}
